module.exports = __webpack_public_path__ + "static/media/bg-about-us@3x.17909b03.jpg";